import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class MobileAppDashboardThumbDetails implements IMobileAppDashboardThumbDetails {
    entryDate!: Date | undefined;
    inThumb!: Date | undefined;
    outThumb!: Date | undefined;
    employee!: EmployeeSummaryDto;

    constructor(data?: IMobileAppDashboardThumbDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.inThumb = _data["inThumb"] ? new Date(_data["inThumb"].toString()) : <any>undefined;
            this.outThumb = _data["outThumb"] ? new Date(_data["outThumb"].toString()) : <any>undefined;
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MobileAppDashboardThumbDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MobileAppDashboardThumbDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["inThumb"] = this.inThumb ? this.inThumb.toISOString() : <any>undefined;
        data["outThumb"] = this.outThumb ? this.outThumb.toISOString() : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMobileAppDashboardThumbDetails {
    entryDate: Date | undefined;
    inThumb: Date | undefined;
    outThumb: Date | undefined;
    employee: EmployeeSummaryDto;
}

